import { render, staticRenderFns } from "./StoryboardFormView.vue?vue&type=template&id=2e026bd1&scoped=true"
import script from "./StoryboardFormView.vue?vue&type=script&lang=js"
export * from "./StoryboardFormView.vue?vue&type=script&lang=js"
import style0 from "./StoryboardFormView.vue?vue&type=style&index=0&id=2e026bd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e026bd1",
  null
  
)

export default component.exports